"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
var Common = /** @class */ (function () {
    function Common() {
    }
    Common.prototype.getType = function (val) {
        return Object.prototype.toString.call(val);
    };
    Common.prototype.isString = function (val) {
        return this.getType(val) === "[object String]";
    };
    Common.prototype.isObject = function (val) {
        return this.getType(val) === "[object Object]";
    };
    Common.prototype.isArray = function (val) {
        return this.getType(val) === "[object Array]";
    };
    Common.prototype.isNumeric = function (val) {
        return !isNaN(val);
    };
    Common.prototype.isDOM = function (val) {
        return /^(\[object\s*)HTML([a-zA-Z]*)(Element\])$/.test(this.getType(val));
    };
    Common.prototype.isSVGDOM = function (val) {
        return /^\[object\sSVG([a-zA-Z]*)Element\]$/.test(this.getType(val));
    };
    Common.prototype.isFunction = function (val) {
        return this.getType(val) === "[object Function]";
    };
    Common.prototype.isNodeList = function (val) {
        return this.getType(val) === "[object NodeList]";
    };
    Common.prototype.isRegExp = function (val) {
        return this.getType(val) === "[object RegExp]";
    };
    Common.prototype.isEmpty = function (val) {
        return val === undefined || val === null || (this.isString(val) && val.length <= 0);
    };
    Common.prototype.isPromise = function (val) {
        return this.getType(val) === "[object Promise]";
    };
    Common.prototype.isBoolean = function (val) {
        return this.getType(val) === "[object Boolean]";
    };
    // tslint:disable-next-line:no-shadowed-variable
    Common.prototype.isEqual = function (a, b) {
        if (a === b) {
            return a !== 0 || 1 / a === 1 / b;
        }
        if (a == null || b == null) {
            return a === b;
        }
        var classNameA = this.getType(a), classNameB = this.getType(b);
        if (classNameA !== classNameB) {
            return false;
        }
        else {
            switch (classNameA) {
                case "[object RegExp]":
                case "[object String]":
                    return "" + a === "" + b;
                case "[object Number]":
                    if (+a !== +a) {
                        return +b !== +b;
                    }
                    return +a === 0 ? 1 / +a === 1 / b : +a === +b;
                case "[object Date]":
                case "[object Boolean]":
                    return +a === +b;
            }
            if (classNameA === "[object Object]") {
                var propsA = Object.getOwnPropertyNames(a), propsB = Object.getOwnPropertyNames(b);
                if (propsA.length !== propsB.length) {
                    return false;
                }
                else {
                    for (var i = 0; i < propsA.length; i++) {
                        var propName = propsA[i];
                        if (a[propName] !== b[propName]) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            if (classNameA === "[object Array]") {
                return a.toString() === b.toString();
            }
        }
    };
    Common.prototype.sleepCall = function (fn, timeout, obj) {
        if (typeof fn === "function") {
            var tim = timeout || 200;
            var sleep = function () {
                if (obj) {
                    fn.call(obj);
                }
                else {
                    fn();
                }
            };
            setTimeout(sleep, tim);
        }
    };
    /**
     * 获取随机ID
     */
    Common.prototype.getRandomID = function () {
        var now = new Date();
        var year = now.getFullYear().toString(), month = now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1).toString() : (now.getMonth() + 1).toString(), date = now.getDate() < 10 ? "0" + now.getDate().toString() : now.getDate().toString(), hour = now.getHours() < 10 ? ["0", now.getHours()].join("") : now.getHours().toString(), minute = now.getMinutes() < 10 ? ["0", now.getMinutes()].join("") : now.getMinutes().toString(), second = now.getSeconds() < 10 ? ["0", now.getSeconds()].join("") : now.getSeconds().toString(), reSecond = now.getMilliseconds();
        var randValue = parseInt((Math.random() * 9999 + 1000).toString(), 10);
        return [year, month, date, hour, minute, second, reSecond, randValue].join("");
    };
    /**
     * 字符串有连接符-将自动转换成已首字母大写
     * @param val 转换文本
     * @param firstUpperCase 是否大写
     */
    Common.prototype.toHumpStr = function (val, firstUpperCase) {
        if (!this.isEmpty(val)) {
            var vStr = val.replace(/(^\-)|(\-$)/, "");
            var vArr = vStr.split("-");
            for (var i = 0; i < vArr.length; i++) {
                if ((i === 0 && firstUpperCase) || i > 0) {
                    vArr[i] = vArr[i].substr(0, 1).toUpperCase() + vArr[i].substr(1);
                }
            }
            return vArr.join("");
        }
        else {
            return val;
        }
    };
    Common.prototype.humpToStr = function (val) {
        if (!this.isEmpty(val)) {
            var vStr = val.substr(0, 1).toLowerCase() + val.substr(1);
            var rStr = vStr.replace(/([A-Z])/g, function ($1) {
                return "-" + $1.toLowerCase();
            });
            return rStr;
        }
        return val;
    };
    Common.prototype.extend = function (desc, src, setReadOnly, ignoreKeys) {
        if (!setReadOnly) {
            if (this.isObject(desc) && this.isObject(src)) {
                if (Object.assign) {
                    Object.assign(desc, src);
                }
                else {
                    // tslint:disable-next-line:forin
                    for (var key in src) {
                        if (!ignoreKeys || ignoreKeys.indexOf(key) < 0) {
                            desc[key] = src[key];
                        }
                    }
                }
            }
        }
        else {
            if (this.isObject(desc) && this.isObject(src)) {
                // tslint:disable-next-line:forin
                for (var key in src) {
                    if (!ignoreKeys || ignoreKeys.indexOf(key) < 0) {
                        // 已经存在的属性需要使用delete删除，防止redine error问题
                        if (desc.hasOwnProperty(key)) {
                            delete desc[key];
                        }
                        this.defineReadOnlyProperty(desc, key, src[key]);
                    }
                }
            }
        }
        return desc;
    };
    Common.prototype.merge = function (obj1, obj2) {
        var result = {};
        if (obj1 && !obj2) {
            result = obj1;
        }
        else if (!obj1 && obj2) {
            result = obj2;
        }
        else if (obj1 && obj2) {
            if (this.isObject(obj1)) {
                // tslint:disable-next-line:forin
                for (var key in obj1) {
                    result[key] = obj1[key];
                }
            }
            if (this.isObject(obj2)) {
                for (var sKey in obj2) {
                    if (!result.hasOwnProperty(sKey)) {
                        result[sKey] = obj2[sKey];
                    }
                }
            }
        }
        return result;
    };
    /**
     * 将字符串转转换成对应的数据类型，遇到true|false转换成bool类型，遇到数字文本转换成数字类型数据
     * @param data 要转换的数据
     */
    Common.prototype.val = function (data) {
        if (this.isString(data)) {
            if (!isNaN(data)) {
                return (data.indexOf(".") >= 0 ? parseFloat(data) : parseInt(data, 10));
            }
            else {
                return (/^(true|false)$/.test(data) ? Boolean(data) : data);
            }
        }
        else {
            return data;
        }
    };
    Common.prototype.defineReadOnlyProperty = function (obj, propertyKey, propertyValue) {
        (function (paramObj, paramPropertyKey, paramPropertyValue) {
            paramObj && Object.defineProperty(paramObj, paramPropertyKey, {
                configurable: true,
                enumerable: true,
                value: paramPropertyValue,
                writable: false
            });
        })(obj, propertyKey, propertyValue);
    };
    Common.prototype.launchFullscreen = function (element) {
        if (element.requestFullscreen) {
            // tslint:disable-next-line: no-floating-promises
            element.requestFullscreen();
        }
        else if (element["mozRequestFullScreen"]) {
            element["mozRequestFullScreen"]();
        }
        else if (element["webkitRequestFullscreen"]) {
            element["webkitRequestFullscreen"]();
        }
        else if (element["msRequestFullscreen"]) {
            element["msRequestFullscreen"]();
        }
    };
    Common.prototype.exitFullscreen = function () {
        if (document.exitFullscreen) {
            // tslint:disable-next-line: no-floating-promises
            document.exitFullscreen();
        }
        else if (document["mozCancelFullScreen"]) {
            document["mozCancelFullScreen"]();
        }
        else if (document["webkitExitFullscreen"]) {
            document["webkitExitFullscreen"]();
        }
    };
    Common.prototype.isFullScreen = function () {
        return document["isFullScreen"] || document["mozIsFullScreen"] || document["webkitIsFullScreen"];
    };
    Common.prototype.guid = function () {
        var S4 = function () {
            // tslint:disable-next-line: no-bitwise
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substr(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4());
    };
    Common.prototype.getUri = function (queryString) {
        var _this = this;
        var strArr = (queryString || "").split("&");
        var result = {};
        strArr.forEach(function (str) {
            var strIndex = str.indexOf("=");
            var strKey = strIndex > 0 ? str.substring(0, strIndex) : str;
            var strValue = strIndex > 0 ? str.substring(strIndex + 1) : true;
            result[strKey] = _this.isString(strValue) ? decodeURIComponent(strValue) : strValue;
        });
        return result;
    };
    Common.prototype.getQuery = function (key, queryStr) {
        var queryString = (queryStr || location.search).replace(/^\?/, "");
        return this.getUri(queryString)[key];
    };
    Common.prototype.invoke = function (fn) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            if (!fn || typeof fn !== "function") {
                reject({
                    statusCode: 500,
                    message: "the fn should be a function."
                });
            }
            else {
                var fnResult = fn.apply(void 0, args);
                if (_this.isPromise(fnResult)) {
                    fnResult.then(resolve).catch(reject);
                }
                else {
                    resolve(fnResult);
                }
            }
        });
    };
    /**
    * 获取字符串字节长度
    * @param {string|number} val 输入字符串
    */
    Common.prototype.strLen = function (val) {
        var str = val.toString();
        var len = 0;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (c > 255) {
                len += 2;
            }
            else {
                len += 1;
            }
        }
        return len;
    };
    Common.prototype.isGlobalObj = function (val) {
        return this.getType(val) === "[object global]";
    };
    Common.prototype.getValue = function (data, key, defaultValue) {
        var keyValue = key !== undefined && key !== null ? key : "";
        if (/\./.test(keyValue)) {
            var keyArr = keyValue.split(".");
            var isFind = false;
            var index = 0;
            var keyStr = "";
            var tmpData = data;
            while (index <= keyArr.length - 1) {
                keyStr = keyArr[index];
                isFind = index === keyArr.length - 1;
                if (this.isArray(tmpData) && this.isNumeric(keyStr)) {
                    keyStr = parseInt(keyStr, 10);
                }
                if (!isFind) {
                    var nextKey = keyArr[keyArr.length - 1];
                    if (this.isArray(tmpData) || this.isObject(tmpData) || this.isGlobalObj(tmpData)) {
                        tmpData = tmpData[keyStr];
                    }
                    if (tmpData && index === keyArr.length - 2) {
                        if (nextKey === "key") {
                            tmpData = tmpData.key;
                            isFind = true;
                        }
                        else if (nextKey === "length") {
                            tmpData = tmpData.length;
                            isFind = true;
                        }
                    }
                }
                else {
                    tmpData = tmpData ? tmpData[keyStr] : undefined;
                }
                if (isFind) {
                    break;
                }
                index++;
            }
            return isFind ? (undefined !== tmpData ? tmpData : defaultValue) : defaultValue;
        }
        else {
            var rResult = data ? data[keyValue] : undefined;
            return data ? (undefined !== rResult ? rResult : defaultValue) : defaultValue;
        }
    };
    /**
     * 给指定对象设置属性值
     * @param data 设置属性值对象
     * @param key 设置属性key,属性key有多层可使用.区分
     * @param value 设置属性值
     * @param fn 自定义设置值回调
     */
    Common.prototype.setValue = function (data, key, value, fn) {
        var isUpdate = false;
        if (!this.isObject(data)) {
            throw new Error("The parameter of data is not a object");
        }
        if (this.isEmpty(key)) {
            throw new Error("The key can not be an empty string");
        }
        if (!this.isEmpty(value)) {
            var keyArr = key.split(".");
            var keyLen = keyArr.length;
            var index = 0;
            var tmpData = data;
            while (index < keyLen) {
                var cKey = keyArr[index];
                if (index < keyLen - 1) {
                    // 不是最后一个节点
                    if (!this.isEmpty(tmpData[cKey])) {
                        if (this.isObject(tmpData[cKey])) {
                            tmpData = tmpData[cKey];
                        }
                        else {
                            throw new Error("Can not set value to attribute of " + cKey);
                        }
                    }
                    else {
                        tmpData[cKey] = {};
                        tmpData = tmpData[cKey];
                    }
                }
                else {
                    // 要更新数据的节点
                    if (typeof fn === "function") {
                        fn(tmpData, cKey, value);
                    }
                    else {
                        tmpData[cKey] = value;
                    }
                    isUpdate = true;
                }
                index++;
            }
        }
        return isUpdate;
    };
    return Common;
}());
exports.Common = Common;
